export function ellipsisMiddle(text, limit = 20) {
  if (text.length < limit) {
    return text;
  }

  const substrNumber = Math.floor((limit - 3) / 2);
  return `${text.substr(0, substrNumber)}...${text.substr(text.length - substrNumber)}`;
}
export function ellipsisEnd(text, limit = 20) {
  if (text.length < limit || limit <= 0) {
    return text;
  }

  return `${text.substr(0, limit)}...`;
}
export function ellipsisMiddleCustom(text, numberCharacter = 6, limit = 20) {
  if (text.length < limit) {
    return text;
  }

  return `${text.substr(0, numberCharacter)}...${text.substr(text.length - numberCharacter)}`;
}
export const formatDynamicString = (str, ...params) => {
  return str.replace(/{(\d+)}/g, function (_m, i) {
    return params[i];
  });
};